
import { useState } from "react";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import EditorFieldSection from "../../../common/editor/EditorFieldSection";
import EditorFormShell from "../../../common/editor/EditorFormShell";
import FieldImage from "./FieldImage";
import FieldText from "./FieldText";
import FieldTitle from "./FieldTitle";


export default function Form() {
	const navigate = useNavigate();
	const [title, setTitle] = useState("");
	const [text, setText] = useState("");
	const [image, setImage] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleTitleChange = (e) => {
		setTitle(e.target.value);
	}

	const handleTextChange = (value) => {
		setText(value);
	}

	const handleImageChange = (e) => {
		setImage(e.target.files[0]);
	}

	const handleSubmit = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.publicationAdd({
			token: LoginHelper.getToken(),
			title: title,
			text: text,
			image_file: image,
		}).then((result) => {
			setIsLoading(false);
			const publicationId = result.id;
			navigate('/publication_detail/' + publicationId + '/');
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<EditorFormShell
			title="ساخت مقاله"
			subtitle="عنوان، متن و تصویر شاخص مقاله را وارد کنید."
			errorMessage={errorMessage}
			onSubmit={handleSubmit}
			isLoading={isLoading}
			submitLabel="انتشار مقاله"
		>
			<EditorFieldSection title="عنوان و متن">
				<FieldTitle title={title} onChange={handleTitleChange} />
				<FieldText text="" onChange={handleTextChange} />
			</EditorFieldSection>
			<EditorFieldSection title="تصویر شاخص">
				<FieldImage onChange={handleImageChange} />
			</EditorFieldSection>
		</EditorFormShell>
	);
}
